import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { useRef } from "preact/hooks";
import { FulfillmentSettingsTracking, GeolocationTracking, t, translate, } from "restaumatic-client";
import Alert from "./Alert";
import ApartmentInfoForm from "./ApartmentInfoForm";
import CheckboxField from "./CheckboxField";
import DeliveryAddressDivider from "./DeliveryAddressDivider";
import LocateMeButton from "./LocateMeButton";
import StreetAddressForm from "./StreetAddressForm";
function DeliveryAddressForm(props) {
    const { controller, deliveryAddressCoordinator, withApartmentInfo, withHiddenNoContactDelivery, showEmptyMessage, viewType, origin, } = props;
    const { deliveryAddressController, apartmentInfoController, fields } = controller;
    const { validationStatus } = deliveryAddressController;
    const { noContactDelivery } = fields;
    const trackingEventHasBeenSent = useRef(false);
    const handleChange = () => {
        deliveryAddressCoordinator.saveUnvalidated();
        if (!trackingEventHasBeenSent.current) {
            FulfillmentSettingsTracking.chooseAddressEvent({ tag: viewType });
            trackingEventHasBeenSent.current = true;
        }
    };
    const handleLocateMe = () => {
        void deliveryAddressCoordinator.locateMe().then((success) => {
            if (success) {
                handleChange();
                handleSave();
            }
        });
    };
    const handleSave = () => {
        void deliveryAddressCoordinator.validateAndForceSave().then(() => {
            GeolocationTracking.findAddressEvent(origin, deliveryAddressController.validationStatus, deliveryAddressController.streetAddress);
        });
    };
    return (h("div", { class: "u-mt2" },
        h(LocateMeButton, { onLocateMe: handleLocateMe, geolocationError: deliveryAddressCoordinator.geolocationError }),
        h("div", { class: "m-delivery-address__container" },
            h(StreetAddressForm, { fieldId: "fulfillmentMethod.deliveryAddress", controller: deliveryAddressController, onChange: handleChange, onBlur: handleSave }),
            withApartmentInfo && (h(Fragment, null,
                h(DeliveryAddressDivider, null),
                h(ApartmentInfoForm, { fieldId: "fulfillmentMethod.deliveryAddress", controller: apartmentInfoController })))),
        withHiddenNoContactDelivery && (h(NoContactDelivery, { field: noContactDelivery })),
        h("div", { class: "m-delivery-address__status" },
            h(AddressStatus, { state: validationStatus, showEmptyMessage: showEmptyMessage }))));
}
const NoContactDelivery = observer((props) => {
    const { field } = props;
    return (h("div", { class: "form-group" },
        h(CheckboxField, { name: "noContactDelivery", dataFieldId: "fulfillmentMethod.deliveryAddress.noContactDelivery", label: translate(t.delivery_method.no_contact_delivery_choice), helpText: translate(t.delivery_method.no_contact_delivery_tooltip), controller: field, required: false })));
});
const AddressStatus = observer((props) => {
    const { state, showLoading = true, showEmptyMessage = true } = props;
    switch (state.type) {
        case "NotRequested":
        case "InvalidAddress":
            return showEmptyMessage ? (h(Alert, { type: "info", icon: "info-sign", message: translate(t.delivery.enter_address) })) : null;
        case "Loading":
            return showLoading ? (h("div", null,
                h("i", { class: "icon-spinner icon-spin u-mr2", "aria-hidden": "true" }),
                translate(t.delivery.geocoding))) : null;
        case "AddressDoesNotExistOrInaccurate":
            return (h(Alert, { type: "danger", message: translate(t.delivery.geocoding_error) }));
        default:
            return null;
    }
});
export default observer(DeliveryAddressForm);
